import React from 'react';
import {endpoints, types} from 'main/tools';
import {observer} from 'mobx-react';
import FilterComponent from './FilterComponent';
import useFetchModels from 'shared/hooks/useFetchModels';
import {fullName} from 'shared/tools';

const GoalEmployee = observer(({filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  const [models, isLoading] = useFetchModels(endpoints.PERFORMANCE_GOALS.FILTERABLE_EMPLOYEES, types.EMPLOYEE);
  const options = models.map(employee => {
    return { label: fullName(employee), value: employee.id };
  });

  return <FilterComponent
    filter={filter}
    filterKey={filterKey}
    options={options}
    filterUpdated={filterUpdated}
    filterDeleted={filterDeleted}
    Wrapper={Wrapper}
    isLoading={isLoading}
    searchable
  />;
});

export default GoalEmployee;
